// generated — do not hand-edit
// The heartbeat cadence, stated ONCE and vendored to the emitter.
//
// The emitter fires one heartbeat per update-check cycle, so this is also the
// tick the emitting side runs at. Both sides bind to this value by test rather
// than by comment: the emitter repo asserts its own tick equals this constant,
// and this service's staleness bands are multiples of it. Changing the number
// here without changing it there fails CI on the other side.
//
// Anything that STATES this cadence in prose to a human is bound to it too —
// derive the rendered string, never retype the number.
export const HEARTBEAT_CADENCE_MS = 3 * 60 * 60 * 1000;
export const HEARTBEAT_CADENCE_HOURS = HEARTBEAT_CADENCE_MS / (60 * 60 * 1000);
